module.exports = __webpack_public_path__ + "static/media/clasesUX-3.c25f8ff5.jpg";